import {
  FRAMEWORK_DISPLAY_ORDER,
  FRAMEWORK_METADATA,
} from "./frameworks.metadata";

// Derived view used by the report-type picker. Shape is preserved for
// backwards compatibility: { key, value, image, summary, usage, points,
// reference, disabled, subFrameworks, subtitle }. Source of truth lives in
// frameworks.metadata.
export const frameworkInfos = FRAMEWORK_DISPLAY_ORDER.map((code) => {
  const meta = FRAMEWORK_METADATA[code];
  if (!meta) return null;
  return {
    key: code,
    value: meta.label,
    image: meta.image,
    summary: meta.summary,
    usage: meta.usage,
    points: meta.points,
    reference: meta.reference,
    disabled: meta.disabled === true,
    subFrameworks: meta.subFrameworks,
    subtitle: meta.subtitle,
  };
}).filter(Boolean);
